import React from "react";
import MainPageWrapper from "../../components/Main-page-wrapper";
import DashFilters from "../../components/Dashboard/FIlters";

export default function DashboardFilters(){
  return <MainPageWrapper>
      <DashFilters/>
  </MainPageWrapper>
}